import { Route } from '/@/modules/core/app/constants/api.constants';
import { BaseEntityService } from '/@/modules/core/app/services/abstracts/BaseEntityService';
import { UserFlow } from '@/modules/user/models/UserFlow';

export class UserFlowService extends BaseEntityService<UserFlow> {
  getRoute(): Route {
    return Route.USERS_USERFLOWS;
  }

  getModel(): typeof UserFlow {
    return UserFlow;
  }
}

export default new UserFlowService();
